// features/payment/constants/payment-tag.constant.ts
export const PAYMENT_TAGS = {
    PAYMENT_LIST: "getPaymentList",
} as const;